import { autoinject } from 'aurelia-dependency-injection';
import { CustomerViewModel } from '@dynamik/common/clients/transaction-clients';
import { CustomersClient } from '@dynamik/common/clients/policy-clients';
import { CacheService } from '@dynamik/common';

@autoinject
export class CustomersCache {
  constructor(private customersClient: CustomersClient, private cacheService: CacheService) { }

  async get(refresh = false) {
    const key = 'customers';

    if (refresh) {
      this.cacheService.delete(key);
    }

    return this.cacheService.getOrSet(
        key,
        async () => await this.customersClient.myCustomers(),
        6000000000
    );
  }
}
